import { defineComponent as T, useModel as $, computed as l, openBlock as n, createElementBlock as c, normalizeClass as u, createVNode as j, unref as m, createCommentVNode as d, createElementVNode as y, createBlock as v, resolveDynamicComponent as z, toRaw as w, toDisplayString as x, mergeModels as D } from "vue";
import { RevSpinner as F } from "@ds/components/Spinner";
import { RevTag as G } from "@ds/components/Tag";
import H from "../../icons/generated/IconChevronDown.vue2.js";
import { tw as a } from "../../utils/tailwind.js";
import { SizesEnum as t } from "./Chip.constant.js";
const J = ["aria-controls", "aria-disabled", "aria-expanded", "aria-label", "disabled", "role"], K = {
  key: 0,
  class: "absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
}, p = /* @__PURE__ */ T({
  name: "RevChip",
  __name: "Chip",
  props: /* @__PURE__ */ D({
    label: {},
    size: { default: () => t.Medium },
    disabled: { type: Boolean, default: !1 },
    isOpen: { type: Boolean, default: !1 },
    isLoading: { type: Boolean, default: !1 },
    startIcon: {},
    endIcon: {},
    hasDropdown: { type: Boolean, default: !1 },
    ariaControls: {},
    ariaExpanded: { type: Boolean, default: !1 }
  }, {
    modelValue: { type: [Array, Boolean], required: !1, default: !1 },
    modelModifiers: {}
  }),
  emits: /* @__PURE__ */ D(["click"], ["update:modelValue"]),
  setup(e, { emit: C }) {
    const k = C, r = $(e, "modelValue"), o = l(
      () => Array.isArray(r.value) ? r.value : []
    ), b = l(() => r.value === !0), i = l(() => o.value.length > 0), S = l(() => o.value.length === 1), V = l(() => o.value.length > 1), B = l(() => o.value.length.toString()), L = l(() => o.value[0]), s = l(() => i.value || b.value), M = l(() => s.value && e.hasDropdown && e.isOpen ? a`bg-action-default-mid-hoverpressed` : s.value ? a`bg-action-default-mid-pressed` : e.hasDropdown && e.isOpen ? a`bg-action-default-mid-hover` : a`bg-action-default-mid`), N = l(() => [
      a`relative block`,
      s.value ? a`text-onaction-default-mid-pressed hover:bg-action-default-mid-hoverpressed` : a`text-onaction-default-mid hover:bg-action-default-mid-hover`,
      M.value,
      a`rounded-full border-1 border-transparent`,
      a`outline-2 outline-offset-4 focus-visible:outline-default-hi`,
      a`motion-safe:transition motion-safe:duration-[225ms]`,
      {
        [t.Large]: [
          a`label-large h-48`,
          e.hasDropdown ? a`pl-12 pr-8` : a`px-12`
        ],
        [t.Medium]: [
          a`label-large h-40`,
          e.hasDropdown ? a`pl-16 pr-12` : a`px-16`
        ],
        [t.Small]: [
          a`label-medium h-32`,
          e.hasDropdown ? a`pl-12 pr-8` : a`px-12`
        ]
      }[e.size],
      s.value ? a`disabled:opacity-40` : a`disabled:bg-action-default-mid-disabled disabled:text-onaction-default-mid-disabled disabled:outline-none`,
      e.isLoading && a`cursor-default`
    ]), I = l(() => [
      e.isLoading && !e.disabled && a`invisible`,
      a`flex items-center`,
      a`gap-4`
    ]), f = l(
      () => ({
        [t.Large]: a`label-large-bold`,
        [t.Medium]: a`label-large-bold`,
        [t.Small]: a`label-medium-bold`
      })[e.size]
    ), A = l(() => [
      {
        [t.Large]: (!i.value || !e.hasDropdown) && a`pr-2`,
        [t.Medium]: i.value || e.hasDropdown ? a`pl-2` : a`px-2`,
        [t.Small]: i.value || e.hasDropdown ? a`pl-2` : a`px-2`
      }[e.size],
      b.value && f.value
    ]), E = l(() => [f.value]), h = l(() => e.size === t.Small ? "16" : "20"), O = l(
      () => e.size === t.Small ? "small" : "medium"
    ), R = l(() => e.size === t.Small ? "small" : "medium");
    function q(g) {
      e.disabled || e.isLoading || k("click", g);
    }
    return (g, P) => (n(), c("button", {
      "aria-controls": e.hasDropdown ? e.ariaControls : void 0,
      "aria-disabled": e.disabled || e.isLoading,
      "aria-expanded": e.hasDropdown ? e.ariaExpanded : void 0,
      "aria-label": e.hasDropdown ? e.label : void 0,
      class: u(N.value),
      disabled: e.disabled,
      role: e.hasDropdown ? "combobox" : "button",
      onClick: q
    }, [
      e.isLoading && !e.disabled ? (n(), c("div", K, [
        j(m(F), { size: O.value }, null, 8, ["size"])
      ])) : d("", !0),
      y("div", {
        class: u(I.value)
      }, [
        e.startIcon ? (n(), v(z(w(e.startIcon)), {
          key: 0,
          "data-test": "chip-start-icon",
          size: h.value
        }, null, 8, ["size"])) : d("", !0),
        y("span", {
          class: u(A.value)
        }, x(e.label), 3),
        i.value && S.value ? (n(), c("span", {
          key: 1,
          class: u(E.value)
        }, x(L.value), 3)) : d("", !0),
        i.value && V.value ? (n(), v(m(G), {
          key: 2,
          class: "mood-inverse",
          label: B.value,
          size: R.value,
          variant: "secondary"
        }, null, 8, ["label", "size"])) : d("", !0),
        e.endIcon || e.hasDropdown ? (n(), v(z(e.hasDropdown ? m(H) : w(e.endIcon)), {
          key: 3,
          "data-test": "chip-end-icon",
          size: h.value
        }, null, 8, ["size"])) : d("", !0)
      ], 2)
    ], 10, J));
  }
});
export {
  p as default
};
